<div
  class="halves"
>
  <div>
    <h4>
      Original

      <motn-pill
        [squareLetter]="'t'"
      >{{ original.ID }}</motn-pill>
    </h4>
  </div>

  <div>
    <div>
      {{original.Name}}
    </div>

    <div>
      <motn-point-definition-pill
        [protocol]="getOriginalTileStructure().Protocol"
        [pointId]="getOriginalTileStructure().PointID"
        [pillShape]="false"
      ></motn-point-definition-pill>
    </div>
  </div>

  <div>
    <h4>
      Clone
    </h4>
  </div>

  <div>
    <input
      [(ngModel)]="clone.Name"
      [disabled]="cloningActive"
      (ngModelChange)="emitUpdate()"
    >
  </div>
</div>
